import React, { useState } from 'react';
import {firebase} from '../../firebase/firebaseConfig';
import { useAuthState } from 'react-firebase-hooks/auth'
import { getPoints } from "../../firebase/authorUtils";
import googleLogo from "./googleLogo.png"

import {Nav, Navbar, Button, Dropdown, NavLink as BootNavLink, Image} from 'react-bootstrap';
import { NavLink, useHistory } from 'react-router-dom';
import Post from './Post';

export default function MyNavbar(props) {
  const [user] = useAuthState(firebase.auth());
  const [numberPoints, setNumberPoints] = useState(null);
  const [openDrop, setOpenDrop] = useState(false);
  const [openPost, setOpenPost] = useState(false);
  let history = useHistory();

  const handleGoogleSignup = () => {
    firebase.analytics().logEvent('login_start', {method: 'Google'});

    const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
    setOpenDrop(false);
    firebase.auth().signInWithPopup(googleAuthProvider)
    .then((authResult) => {
      const newUser = authResult.additionalUserInfo.isNewUser;
      props.setNewUser(newUser)
      if (newUser) setNumberPoints(0);
      else getPoints(authResult.user.uid, setNumberPoints);
    })
    .then(() => firebase.analytics().logEvent('login', {method: 'Google'}))
    .catch(function(error) {
      console.error(error.code, error.message);
    });
  }

  const logout = () => {
    firebase.auth().signOut().then(function() {
    }).catch(function(error) {
      console.error(error.code, error.message)
    });
  }

  const showProfile = () => {
    history.push(`/users/${user.uid}`)
  };

  if (user && !numberPoints) getPoints(user.uid, setNumberPoints);

  return (
    <div>
      <Navbar id="theme-bg" expand="lg" fixed="top">
        <Navbar.Toggle className="mr-auto" aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Navbar.Brand className="remove-brand-margin-on-toggle px-3 font-weight-bold theme-link" href="/">Sustainably</Navbar.Brand>

          <Nav className="mr-auto">
            <Nav.Link className="theme-link" as={NavLink} to="/" >Forum</Nav.Link>
            <Nav.Link onClick={logout} className="d-block d-sm-none theme-link">Logout</Nav.Link>
            <Nav.Link className="theme-link" onClick={() => window.open("https://forms.gle/SugKsKSfFsVTS4Wc8")}>Bugs</Nav.Link>
          </Nav>
        </Navbar.Collapse>
        {
            user ?
            <>
              {numberPoints !== null ? <Navbar.Text className="pr-5 text-light mr-sm-auto">{`${numberPoints} points`}</Navbar.Text> : ""}
              <Button variant="light" className="px-4" onClick={() => {setOpenPost(true);firebase.analytics().logEvent('post_create_start');}}>Post</Button>
              <Dropdown show={openDrop} onMouseEnter={() => setOpenDrop(true)} onMouseLeave={() => setOpenDrop(false)} className="d-sm-block d-none">
                <Dropdown.Toggle as={BootNavLink} className="text-light"></Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={showProfile}>Profile</Dropdown.Item>
                  <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Image src={user.photoURL} alt="user-profile" roundedCircle width={40} className="d-sm-block d-none"/>
            </>
            :
              <Button variant="light" className="ml-auto" onClick={handleGoogleSignup}>
                <span className="align-middle">
                  <Image src={googleLogo} width={20} className="mb-1 mr-3"/>Sign in
                </span>
              </Button>
          }
      </Navbar>
      {user && <Post show={openPost} setOpen={setOpenPost} uid={user.uid} displayName={user.displayName}/>}
    </div>
  )
}
